import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29e805a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "mxa-dsec-msg",
  "data-test": "title"
}
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "container-fluid mb-2 flex-grow-1" }
const _hoisted_5 = {
  key: 1,
  class: "row justify-content-center mxa-download-detail-row",
  "data-test": "attached"
}
const _hoisted_6 = { class: "col-12 col-md-3" }
const _hoisted_7 = {
  key: 0,
  class: "mxa-download-detail-row-title",
  "data-test": "title_attached"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "container-fluid mb-2 p-0" }
const _hoisted_12 = { class: "row justify-content-center p-0" }
const _hoisted_13 = {
  key: 0,
  class: "col-12 col-md-6 pb-2"
}
const _hoisted_14 = {
  key: 1,
  class: "col-12 col-md-6"
}
const _hoisted_15 = { class: "mxa-dsec-msg" }
const _hoisted_16 = { "data-test": "decompression-notes" }
const _hoisted_17 = { "data-test": "decompression-note-1" }
const _hoisted_18 = { "data-test": "decompression-note-2" }
const _hoisted_19 = { "data-test": "ios-device-notes" }
const _hoisted_20 = { "data-test": "ios-device-note-1" }
const _hoisted_21 = { "data-test": "ios-device-note-2" }
const _hoisted_22 = { class: "mxa-loading text-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-dark",
  role: "status"
}, null, -1))
const _hoisted_24 = { class: "mxa-loading-text" }
const _hoisted_25 = ["action"]

import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store'
import {
  useDownloadDetail,
  useErrorMsg,
  useState,
  download,
  useErrorFailState,
} from '@/model/components/users/userDownloadDetail'
import * as filesize from '@/model/util/file/fileUtil'
import ErrorMessage from '@/components/common/screen/ErrorMessage.vue'
import BaseButton from '@/components/common/button/BaseButton.vue'
import { DOWNLOAD_TYPE } from '@/model/api/user/apiUserDownload'
import * as log from '@/model/util/log/Logger'
import baseconfig from '@/assets/config'
import DownLoadDetailDispBase from '@/components/main/contents/download/DownLoadDetailDispBase.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DownLoadDetail',
  props: {
  // 失敗メッセージ
  failmsg: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

log.trace(`DownloadDetail setup start.`)

// プロパティ定義


const i18n = useI18n()
// 状態
const store = useStore()
const router = useRouter()
const errorState = useErrorMsg()
const state = useState(props, store)

const { detailinfo } = useDownloadDetail(store)
const filesizeByteDisp = filesize.convertByteDisp
const filesizeDisp = filesize.convertDisp
const errorFailState = useErrorFailState(props)

/**
 * ダウンロードボタンクリック処理
 */
const onclick = async (type: string) => {
  log.trace(`DownLoadDetail onclick start. key:${state.key}, type:${type}`)
  await download(state, type, store, router, errorState, errorFailState, i18n, baseconfig.users.download.runStartSleep)
  log.trace(`DownLoadDetail onclick end.`)
}

log.trace(`DownloadDetail setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(state).failDisp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(ErrorMessage, {
            error: _unref(errorFailState),
            "data-test": "error_fail"
          }, null, 8, ["error"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('body.main.download.detail.message')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(DownLoadDetailDispBase, {
          "item-label": _ctx.$t('body.main.download.detail.label.senddate'),
          "item-value": _unref(detailinfo).senddate,
          "data-test": "senddate"
        }, null, 8, ["item-label", "item-value"]),
        _createVNode(DownLoadDetailDispBase, {
          "item-label": _ctx.$t('body.main.download.detail.label.from'),
          "item-value": _unref(detailinfo).from,
          "data-test": "from"
        }, null, 8, ["item-label", "item-value"]),
        _createVNode(DownLoadDetailDispBase, {
          "item-label": _ctx.$t('body.main.download.detail.label.subject'),
          "item-value": _unref(detailinfo).subject,
          "data-test": "subject"
        }, null, 8, ["item-label", "item-value"]),
        (_unref(detailinfo).dispEml)
          ? (_openBlock(), _createBlock(DownLoadDetailDispBase, {
              key: 0,
              "item-label": _ctx.$t('body.main.download.detail.label.size'),
              "item-value": String(_unref(detailinfo).size),
              isFilesize: true,
              "data-test": "size"
            }, null, 8, ["item-label", "item-value"]))
          : _createCommentVNode("", true),
        (_unref(detailinfo).dispAttached)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detailinfo).attached, (file, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("div", _hoisted_6, [
                    (index === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('body.main.download.detail.label.attached')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    title: file.size,
                    class: "col-12 col-md-9 d-flex"
                  }, [
                    _createElementVNode("div", {
                      title: file.name,
                      class: "mxa-download-detail-row-body-attached-name p-0",
                      "data-test": "body_attached_name"
                    }, _toDisplayString(file.name), 9, _hoisted_9),
                    _createElementVNode("div", {
                      title: _unref(filesizeByteDisp)(file.size),
                      class: "mxa-download-detail-row-body-attached-size p-0 text-end",
                      "data-test": "body_attached_size"
                    }, _toDisplayString(_unref(filesizeDisp)(file.size)), 9, _hoisted_10)
                  ], 8, _hoisted_8)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ErrorMessage, {
        error: _unref(errorState),
        "data-test": "error"
      }, null, 8, ["error"]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_unref(detailinfo).dispAttached)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(BaseButton, {
                  isDisabled: _unref(state).loading,
                  label: _ctx.$t('body.main.download.detail.button.label.attached'),
                  onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (onclick(_unref(DOWNLOAD_TYPE).FILE))),
                  "data-test": "attached_button"
                }, null, 8, ["isDisabled", "label"])
              ]))
            : _createCommentVNode("", true),
          (_unref(detailinfo).dispEml)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(BaseButton, {
                  isDisabled: _unref(state).loading,
                  label: _ctx.$t('body.main.download.detail.button.label.mail'),
                  onButtonClick: _cache[1] || (_cache[1] = ($event: any) => (onclick(_unref(DOWNLOAD_TYPE).MAIL))),
                  "data-test": "mail_button"
                }, null, 8, ["isDisabled", "label"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('body.main.download.detail.notes.decompression.messages1')), 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('body.main.download.detail.notes.decompression.messages2')), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('body.main.download.detail.notes.ios-device.messages1')), 1),
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('body.main.download.detail.notes.ios-device.messages2')), 1)
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(state).loadingLable), 1)
      ], 512), [
        [_vShow, _unref(state).loading]
      ])
    ]),
    _withDirectives(_createElementVNode("form", {
      action: _unref(state).url,
      method: "post",
      id: "download_form",
      "data-test": "download_form"
    }, null, 8, _hoisted_25), [
      [_vShow, false]
    ])
  ]))
}
}

})